// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1gqlH","productName":"Table_productName__2zVHB"};